import React, { Component, Fragment } from "react";
import GroupBarchart from "../../../../../d3Components/NewBarchart/GroupBarchart";
import Legend from "../../../../../d3Components/legend";
import SimpleTable from "../../../common/simpleTable";
import WithCard from "../../../../../common/withCard";
import $ from "jquery";

class Volatility extends Component {
  _isMounted = false;
  state = {
    Data1: [],
    FilteredData: [],
    initialWidth: 0,
  };
  componentDidMount() {
    this._isMounted = true;
    let res = this.props.getBacktest;
    if (res.getPortfolioMetrics["length"] != 0) {
      let Data = res.getPortfolioMetrics[0];

      let obj1 = {};
      obj1["Portfolio"] = Data["fund_annualized_return"];
      obj1["Benchmark"] = Data["bm_annualized_return"];
      obj1["metric_name"] = "Return";

      let obj2 = {};
      obj2["Portfolio"] = Data["fund_annualized_vol"];
      obj2["Benchmark"] = Data["bm_annualized_vol"];
      obj2["metric_name"] = "Volatility";
      let data = [{ ...obj1 }, { ...obj2 }];

      let LayoutWidth = $(".container-wrapper").width() - 30 - 65 - 65;
      let initialWidth = (LayoutWidth / 100) * 40;

      this.setState({
        Data1: res,
        FilteredData: data,
        initialWidth: initialWidth,
      });
    } else {
      null;
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  render() {
    const { FilteredData, initialWidth } = this.state;
    const { typeName, benchmark_name } = this.props;
    const rowHead2 = typeName ? typeName : "Benchmark *";

    return (
      <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
        <WithCard>
          <h4 className="text-uppercase bold">return vs. volatility</h4>
          {FilteredData.length ? (
            <div style={{ overflowX: "auto", maxWidth: "500" }}>
              <Legend height={30} width={500} legend2={typeName} />
              {initialWidth > 0 ? (
                <GroupBarchart
                  width={initialWidth}
                  height={300}
                  data={FilteredData}
                  targetDiv="backtestBarChart3"
                />
              ) : null}
            </div>
          ) : null}

          {this._isMounted ? (
            <Fragment>
              <SimpleTable
                rowHead1={"Portfolio"}
                rowHead2={rowHead2}
                heading={FilteredData.map((d, i) => {
                  return <td key={i}>{d.metric_name}</td>;
                })}
                Row1={FilteredData.map((d, i) => {
                  return <td key={i}>{`${d.Portfolio} %`}</td>;
                })}
                Row2={FilteredData.map((d, i) => {
                  return <td key={i}>{`${d.Benchmark} %`}</td>;
                })}
              />
              {benchmark_name ? (
                <div>
                  <small>
                    <b>*</b>&nbsp; {benchmark_name}
                  </small>
                </div>
              ) : null}
            </Fragment>
          ) : null}
        </WithCard>
      </div>
    );
  }
}

export default Volatility;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/backtest/returns/section2/volatility.jsx